module.exports = __webpack_public_path__ + "static/galexis-0b4dfa56ec6bdb976f0f2fae9b5ac96c.png";